import { render, staticRenderFns } from "./message-custom.vue?vue&type=template&id=575cf5fe"
import script from "./message-custom.vue?vue&type=script&lang=ts"
export * from "./message-custom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports